import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=36a8c420"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a8c420')) {
      api.createRecord('36a8c420', component.options)
    } else {
      api.reload('36a8c420', component.options)
    }
    module.hot.accept("./actions.vue?vue&type=template&id=36a8c420", function () {
      api.rerender('36a8c420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/trailer/components/actions.vue"
export default component.exports